import PolicyPDF from "../components/PolicyPDF";
import "../css/policy.css";

const sections = [
  {
    title: "1. Introduction",
    paragraphs: [
      "IGC Print Press respects the privacy of customers and visitors who use our website or engage our printing services.",
      "This policy explains the types of information we may collect and how that information may be used in connection with our business operations.",
    ],
  },
  {
    title: "2. Information We Collect",
    paragraphs: [
      "Depending on how you interact with us, we may collect information such as your name, phone number, email address, delivery details, order information, payment-related information, and information you provide when requesting a quote.",
      "Customers may also provide artwork or other files required to fulfil a printing order.",
    ],
  },
  {
    title: "3. How We Use Information",
    paragraphs: [
      "Information may be used for the following purposes:",
    ],
    bullets: [
      "Respond to enquiries and quote requests.",
      "Process and manage printing orders.",
      "Communicate with customers about their orders.",
      "Arrange collection or delivery where applicable.",
      "Maintain business and transaction records.",
      "Improve our services and customer experience.",
    ],
  },
  {
    title: "4. Artwork and Uploaded Files",
    paragraphs: [
      "Files supplied for printing or design services may contain personal or business information. Such files are used primarily for fulfilling the relevant customer request.",
      "Customers should avoid uploading information that is not necessary for the requested service.",
    ],
  },
  {
    title: "5. Payment Information",
    paragraphs: [
      "Payment processing may be handled by third-party payment providers. Payment information may therefore be processed according to the provider's own terms and privacy policies.",
      "IGC Print Press does not need to store customers' full card details to process ordinary orders.",
    ],
  },
  {
    title: "6. Sharing Information",
    paragraphs: [
      "We may share relevant information with service providers where necessary to fulfil an order or operate our business, such as payment providers, delivery providers, hosting providers, or technology service providers.",
      "We do not sell customer information as a business activity.",
    ],
  },
  {
    title: "7. Data Security",
    paragraphs: [
      "We take reasonable measures to protect information against unauthorised access, alteration, disclosure, or loss. However, no internet-based system can be guaranteed to be completely secure.",
    ],
  },
  {
    title: "8. Data Retention",
    paragraphs: [
      "Information may be retained for as long as reasonably necessary for order fulfilment, business records, customer service, accounting, legal, or regulatory purposes.",
    ],
  },
  {
    title: "9. Your Rights",
    paragraphs: [
      "Depending on applicable law, you may have rights concerning your personal information, including rights relating to access, correction, deletion, or other lawful requests.",
    ],
  },
  {
    title: "10. Changes to This Policy",
    paragraphs: [
      "This Privacy Policy may be updated from time to time to reflect changes to our services, business practices, or applicable requirements.",
    ],
  },
  {
    title: "11. Contact",
    paragraphs: [
      "Privacy-related enquiries can be directed to IGC Print Press on +234 803 773 8028.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div className="wrap">
        <div className="policy-hero">
          <span className="hero-tag">
            <span className="pulse" />
            IGC PRINT PRESS
          </span>

          <h1 className="policy-title">
            Privacy Policy
          </h1>

          <p className="policy-intro">
            This Privacy Policy explains how IGC Print Press collects,
            uses, stores, and protects information submitted through our
            website and services.
          </p>

          <span className="policy-updated">
            Last updated: September 2026
          </span>
        </div>

        <PolicyPDF
          title="Privacy Policy"
          filename="IGC-Print-Press-Privacy-Policy.pdf"
          sections={sections}
        >
          <div className="policy-content">
            {sections.map((section) => (
              <section key={section.title}>
                <h2>{section.title}</h2>

                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}

                {section.bullets && (
                  <ul>
                    {section.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </PolicyPDF>
      </div>
    </div>
  );
}